import { Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { IChildrenProps } from 'types/ChildrenProps';
import { IElementProps } from 'types/ElementProps';
import './DashboardRibbon.scss';

export interface IDashboardRibbonProps extends IChildrenProps {
  onClick?: IElementProps<HTMLDivElement>['onClick'];
  style?: IElementProps<HTMLDivElement>['style'];
  theme: Theme.DARK | Theme.LIGHT;
  className?: string | object;
}

function DashboardRibbon(props: IDashboardRibbonProps) {
  const { onClick, style, children, theme, className } = props;

  const classes = classNames('dashboard-ribbon', theme, { clickable: onClick !== undefined }, className);

  return (
    <div className={classes} onClick={onClick} style={style}>
      {children}
    </div>
  );
}

export default DashboardRibbon;
